import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = { data: null, fetchedAt: 0 };
const TTL_MS = 5 * 60 * 1000;

export const HERO_FALLBACK = {
  enabled: true,
  top_label: "Shakti Wings Community",
  top_label_emoji: "🦋",
  heading: "Build Your Career. Create Your Identity.",
  heading_emoji: "🚀",
  subheading: "Learn · Earn · Lead · Grow",
  subheading_emoji: "✨",
  tagline: "घर से शुरुआत, सफलता की नई उड़ान!",
  pill_label: "Career & Growth",
  pill_subtitle: "Opportunities",
  features: [
    "Skill Development Programs",
    "Leadership Growth Path",
    "Business & Sales Training",
    "Community Recognition",
    "Flexible Income Opportunities",
    "Personal Branding Support",
  ],
  button1_label: "Explore Opportunities",
  button1_link: "/marketplace",
  button2_label: "View Growth Path",
  button2_link: "/guide",
  button3_label: "Join the Community",
  button3_link: "/auth?mode=signup",
};

export function useHeroConfig() {
  const [config, setConfig] = useState(() =>
    _cache.data && Date.now() - _cache.fetchedAt < TTL_MS ? _cache.data : HERO_FALLBACK
  );
  const [loading, setLoading] = useState(!_cache.data);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/hero-config");
      const merged = { ...HERO_FALLBACK, ...r.data };
      setConfig(merged);
      _cache = { data: merged, fetchedAt: Date.now() };
    } catch (e) {
      setConfig(HERO_FALLBACK);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!_cache.data || Date.now() - _cache.fetchedAt > TTL_MS) refresh();
    else setLoading(false);
  }, [refresh]);

  return { config, loading, refresh };
}

export function invalidateHeroConfigCache() {
  _cache = { data: null, fetchedAt: 0 };
}
